export default __webpack_public_path__ + "static/media/collection-icon.c12d1e6f.svg";